import {TicketWithFormattedSalePeriod} from '@wix/events-types'
import React from 'react'
import {PricingOptions} from '../../../pricing-options'
import {SoldOutBadge} from '../../../fields/sold-out-badge'
import {SaleEndedBadge} from '../../../fields/sale-ended-badge'
import {TicketQuantity} from '../../../fields/ticket-quantity'
import {TicketPrice} from '../../../fields/ticket-price'
import {PriceQuantityContainer} from './price-quantity-container'

export const PriceQuantitySection = ({ticket}: {ticket: TicketWithFormattedSalePeriod}) => {
  return (
    <>
      <PriceQuantityContainer
        left={<TicketPrice ticket={ticket} />}
        right={
          <>
            <SoldOutBadge ticket={ticket} />
            <SaleEndedBadge ticket={ticket} />
            <TicketQuantity ticket={ticket} />
          </>
        }
      />
      <PricingOptions ticket={ticket} />
    </>
  )
}
